import get from 'lodash/get';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var ABC = "abcdefghijklmnopqrstuvwxyz".split("");
var ABC_CAPITALIZED = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
var DIGITS = "0123456789".split("");
// cspell:disable-next-line
var UMLAUTS = "\xc4\xd6\xdc\xdf\xe4\xf6\xfc".split("");
// cspell:disable-next-line
var FRENCH_SPECIAL_CHARS = "\xe0\xe2\xe4\xe7\xe9\xe8\xea\xeb\xee\xef\xf4\xf6\xf9\xfb\xfc\xff\xc0\xc2\xc4\xc7\xc9\xc8\xca\xcb\xce\xcf\xd4\xd6\xd9\xdb\xdcŸ\xc6Œ\xe6œ".split("");
// cspell:disable-next-line
var DUTCH_SPECIAL_CHARS = "\xe1\xe9\xed\xf3\xfa\xe0\xe8\xeb\xef\xf6\xfcĳ\xc1\xc9\xcd\xd3\xda\xc0\xc8\xcb\xcf\xd6\xdcĲ".split("");
// cspell:disable-next-line
var SPANISH_SPECIAL_CHARS = "\xf1\xd1\xe1\xe9\xed\xf3\xfa\xc1\xc9\xcd\xd3\xda".split("");
var LATIN_SPECIAL_CHARS = _to_consumable_array(UMLAUTS).concat(_to_consumable_array(FRENCH_SPECIAL_CHARS), _to_consumable_array(DUTCH_SPECIAL_CHARS), _to_consumable_array(SPANISH_SPECIAL_CHARS));
var RegexPattern;
(function(RegexPattern) {
    RegexPattern["Email"] = '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
    RegexPattern["Digits"] = "^\\d+$";
})(RegexPattern || (RegexPattern = {}));
function getRandomId() {
    return Math.random().toString(36).substring(2);
}
function realLength(value) {
    return Array.from(value).length; // due to emoji being multiple chars in some cases...
}
function truncateTo(length, string) {
    return Array.from(string).slice(0, length).join(""); // hack to substring emoji properly
}
var defaultInterpolationOptions = {
    startChar: "{",
    endChar: "}",
    fnCallStartChar: "(",
    fnCallEndChar: ")",
    pipeSeparator: "|",
    encode: false
};
/**
 * Interpolates a string with the given map.
 * Example: interpolate('Hello {name}', { name: 'John' }) => 'Hello John'
 * @param str - the string to interpolate
 * @param map - the map to use for interpolation
 * @param options - optional options to change the interpolation behavior
 * @param options.startChar - the start character of the interpolation (default: '{')
 * @param options.endChar - the end character of the interpolation (default: '}')
 * @param options.fnCallStartChar - the start character of a function call (default: '(')
 * @param options.fnCallEndChar - the end character of a function call (default: ')')
 * @param options.pipeSeparator - the separator for function calls (default: '|')
 * @param options.encode - whether to encode the result (default: false)
 * @returns the interpolated string
 * @example
 * interpolate('Hello {name}', { name: 'John' }) => 'Hello John'
 * interpolate('Hello {user.name}', { user: { name: 'John' } }) => 'Hello John'
 * interpolate('Hello {name | uppercase}', { name: 'John', uppercase: (str: string) => str.toUpperCase() }) => 'Hello JOHN'
 * interpolate('Hello {names | join(" & ")}', { names: ['John', 'Jane'], join: (sep: string, values: string[]) => values.join(sep) }) => 'Hello John & Jane'
 * interpolate('Hello {name}', { name: 'John&Jane' }, { encode: true }) => 'Hello John%26Jane'
 * interpolate('Hello [name]', { name: 'John' }, { startChar: '[', endChar: ']' }) => 'Hello John'
 * interpolate('Hello {names | join[" & "]}', { names: ['John', 'Jane'], join: ... }, { fnCallStartChar: '[', fnCallEndChar: ']' }) => 'Hello John & Jane'
 * interpolate('Hello {name -> uppercase}', { name: 'John', uppercase: ... }, { pipeSeparator: '->' }) => 'Hello John'
 *
 */ function interpolate(str, map) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultInterpolationOptions, _ref_startChar = _ref.startChar, startChar = _ref_startChar === void 0 ? defaultInterpolationOptions.startChar : _ref_startChar, _ref_endChar = _ref.endChar, endChar = _ref_endChar === void 0 ? defaultInterpolationOptions.endChar : _ref_endChar, _ref_fnCallStartChar = _ref.fnCallStartChar, fnCallStartChar = _ref_fnCallStartChar === void 0 ? defaultInterpolationOptions.fnCallStartChar : _ref_fnCallStartChar, _ref_fnCallEndChar = _ref.fnCallEndChar, fnCallEndChar = _ref_fnCallEndChar === void 0 ? defaultInterpolationOptions.fnCallEndChar : _ref_fnCallEndChar, _ref_pipeSeparator = _ref.pipeSeparator, pipeSeparator = _ref_pipeSeparator === void 0 ? defaultInterpolationOptions.pipeSeparator : _ref_pipeSeparator, _ref_encode = _ref.encode, encode = _ref_encode === void 0 ? defaultInterpolationOptions.encode : _ref_encode;
    var regExp = new RegExp("\\".concat(startChar, "([^").concat(startChar).concat(endChar, "]+)\\").concat(endChar), "g");
    var interpolatedStr = str.replaceAll(regExp, function(sub, key) {
        var parts = key.split(pipeSeparator).map(function(part) {
            return part.trim();
        });
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var value = get(map, parts[0]);
        for(var i = 0; i < parts.length; i++){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var _parts_i_split = _sliced_to_array(parts[i].split(fnCallStartChar), 2), funcName = _parts_i_split[0], params = _parts_i_split[1];
            var parsedParams = [];
            try {
                parsedParams = params != null ? JSON.parse("[".concat(params.split(fnCallEndChar)[0], "]")) : [];
            } catch (e) {
                return sub;
            }
            var func = map[funcName];
            if (typeof func === "function") {
                value = func.apply(void 0, _to_consumable_array(parsedParams).concat([
                    value
                ]));
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        return value == null ? sub : encode ? encodeURIComponent(value.toString()) : value.toString();
    });
    return regExp.test(interpolatedStr) && interpolatedStr !== str ? interpolate(interpolatedStr, map, {
        startChar: startChar,
        endChar: endChar
    }) : interpolatedStr;
}
function isDigits(string) {
    return new RegExp(RegexPattern.Digits).test(string);
}
function isValidEmail(string) {
    return new RegExp(RegexPattern.Email).test(string);
}
function replaceCharAt(string, at, withChar) {
    return at < 0 || at >= string.length ? string : string.substr(0, at) + withChar + string.substr(at + 1);
}
function lowerCaseFirstLetter(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}
function snakeCaseToReadable(string) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    return capitalize(string.replaceAll("_", delimiter));
}
function camelCaseToReadable(string) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    return capitalize(string.replaceAll(/([A-Z]|\d+)/g, "".concat(delimiter, "$1").toLocaleLowerCase()).toLowerCase());
}
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function titlize(string) {
    var splitStr = string.toLowerCase().split(" ");
    return splitStr.map(function(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }).join(" ");
}
function titlizeCapitalizeFirstLetter(string) {
    var lowercaseString = string.toLowerCase();
    return capitalize(lowercaseString);
}
function vowel(str) {
    var pattern = /^([aeiou])/i;
    return pattern.test(str) ? "an" : "a";
}
function removeNonNumeric(value) {
    return value.replaceAll(/\D/g, "");
}
function removeNullBytes(value) {
    return value.replaceAll("\x00", "");
}
function stringSort(a, b) {
    var ascending = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return ascending ? stringSortAsc(a, b) : stringSortDesc(a, b);
}
function stringSortAsc(a, b) {
    return a.localeCompare(b);
}
function stringSortDesc(a, b) {
    return b.localeCompare(a);
}
function nullifyEmptyString(str) {
    var trimmedStr = str.trim();
    return trimmedStr.length === 0 ? undefined : trimmedStr;
}
/**
 * Shape a string into initials.
 *
 * @example
 * toInitials('Alex Murphy'); // 'AM'
 * toInitials('Cascading Style Sheets'); // 'CSS'
 * toInitials('Clark Richard County', { isShort: true }); // 'CC'
 */ function toInitials() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        isShort: false
    };
    var parts = input.trim().split(" ");
    var isMoreThanOneWord = parts.length > 1;
    var initials = parts.filter(Boolean).map(function(part) {
        return part.charAt(0).toUpperCase();
    });
    if (options.isShort && isMoreThanOneWord) {
        return [
            initials[0],
            initials[initials.length - 1]
        ].join("");
    }
    return initials.join("");
}
// Custom transformation function which returns an array of strings given a value and a separator
// To be used in the class-transformers `Transform` function
function splitAndTrim(transformParams) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    var value = transformParams.value;
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === "string") {
        return value.split(separator).map(function(str) {
            return str.trim();
        });
    }
    return Object.values(value);
}
// Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
function escapeRegExp(string) {
    return string.replaceAll(/[.*+?^${}()|[\]\\/]/g, "\\$&"); // $& means the whole matched string
}
/**
 * Validate that a string has at least a certain number of words,
 * and if using the `chars` option, that each word has at least a certain number of characters.
 *
 * @example
 * minWords('Hello world', { words: 2, chars: 2 }); // true
 * minWords('Hello world', { words: 3, chars: 2 }); // false
 * minWords('Hello world', { words: 2, chars: 10 }); // false
 */ function minWords(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        chars: 2,
        words: 2
    };
    var chars = options.chars, words = options.words;
    var wordsArr = value.split(" ").filter(Boolean);
    if (wordsArr.length > options.words) {
        return true;
    }
    if (wordsArr.length < words) {
        return false;
    }
    if (chars != null) {
        return wordsArr.every(function(word) {
            return word.length >= chars;
        });
    }
    return true;
}
/**
 * Converts empty strings to null, preserving null or undefined values.
 *
 * @example
 * emptyToNull(''); // null
 * emptyToNull(' '); // null
 * emptyToNull(null); // null
 * emptyToNull(' foo '); // 'foo'
 * emptyToNull(undefined); // undefined
 */ function emptyToNull(value) {
    if (value == null) {
        return value;
    }
    var trimmedValue = value.trim();
    return trimmedValue === "" ? null : trimmedValue;
}

export { ABC, ABC_CAPITALIZED, DIGITS, DUTCH_SPECIAL_CHARS, FRENCH_SPECIAL_CHARS, LATIN_SPECIAL_CHARS, RegexPattern, SPANISH_SPECIAL_CHARS, UMLAUTS, camelCaseToReadable, capitalize, emptyToNull, escapeRegExp, getRandomId, interpolate, isDigits, isValidEmail, lowerCaseFirstLetter, minWords, nullifyEmptyString, realLength, removeNonNumeric, removeNullBytes, replaceCharAt, snakeCaseToReadable, splitAndTrim, stringSort, stringSortAsc, stringSortDesc, titlize, titlizeCapitalizeFirstLetter, toInitials, truncateTo, vowel };
